import { useEffect, useState } from 'react';
import { useMapInstance } from 'shared/map-exports';

export const useMapBearing = (): number | undefined => {
  const map = useMapInstance();
  const [bearing, setBearing] = useState<number | undefined>(() =>
    map?.getBearing(),
  );

  useEffect(() => {
    if (!map) {
      return () => {};
    }

    const handleRotate = (): void => {
      setBearing(map.getBearing());
    };

    map.on('rotate', handleRotate);

    return () => {
      map.off('rotate', handleRotate);
    };
  }, [map]);

  return bearing;
};
